import axios from '@util/axios';

class OTPService {
  async getDevices() {
    return await axios({
      url: '/auth/totp/device/',
    });
  }

  async removeDevice() {
    return await axios({
      url: '/auth/totp/device/remove/',
      method: 'POST',
    });
  }

  async verifyDevice(token) {
    return await axios({
      url: '/auth/totp/verify/',
      method: 'POST',
      data: {
        token: token,
      },
    });
  }

  async verify(email, password, token, type = 'email') {
    return await axios({
      url: '/auth/login-otp/',
      method: 'POST',
      data: {
        email: email,
        password: password,
        token: token,
      },
    });
  }
}

export default new OTPService();
